import { APPOINTMENT_WITH_SITE_CONTACT_STATUSES } from 'features/order-tracker/store/sagas/services/helpers/constants';
import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class Kci2AssureAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (): common.ContactUsInfo => CONTACT_US_INFO_TYPE.Kci2Assure;

  isAmendable = (): boolean => false;

  isApplicable = (appointment: common.EngineerAppointment): boolean =>
    appointment.isKci2AssureOrder;

  isHelpSectionAvailable = (): boolean => false;

  isReminderAvailable = (): boolean => false;

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_WITH_SITE_CONTACT_STATUSES.includes(appointment.status) && !!appointment.siteContact;
}
